<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const titrePrincipal = ref(null)

const props = defineProps({
  modeDepositaire: {
    type: Boolean,
    default: false,
  },
})

onMounted(() => {
  document.title = 'Achat terminé - Lulu en bus'

  if (titrePrincipal.value) {
    titrePrincipal.value.focus()
  }
})
</script>

<template>
  <div v-if="!modeDepositaire" class="text-center container">
    <h1 ref="titrePrincipal" tabindex="-1">Achat terminé</h1>

    <h2 class="h3 my-5">Merci pour votre achat</h2>

    <p>Votre commande n° {{ route.query.numeroCommande }} a été enregistrée.</p>

    <p>
      Un email vient de vous être envoyé contenant le QR code représentant votre
      ticket électronique.
    </p>
    <p>
      Conservez-le précieusement, vous devrez le présenter au conducteur lors de
      votre montée !
    </p>

    <img
      width="30%"
      :src="route.query.qrCodeUrl"
      alt="QR code de votre ticket électronique"
    />

    <a class="bouton_valid btn btn-lg" href="https://lulu-mobilite.fr">
      Retour à l'accueil du site Lulu en bus
    </a>
  </div>

  <div v-else class="text-center container">
    <h1 class="py-3 py-sm-5" ref="titrePrincipal" tabindex="-1">
      Rechargement effectué avec succès
    </h1>
    <p>La commande n° {{ route.query.numeroCommande }} a été enregistrée.</p>

    <p>
      Un email vient d'être envoyé à l'usager contenant le QR code représentant le
      ticket électronique.
    </p>

    <img
      width="30%"
      :src="route.query.qrCodeUrl"
      alt="QR code du ticket électronique"
    />

    <router-link class="bouton_valid btn btn-lg" to="rechargement">
      Retour au menu Dépositaire
    </router-link>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3rem;
  @media (max-width: 576px) {
    width: 30%;
  }
}

.bouton_valid {
  display: inline-block;
  margin: 2rem auto;
  @include boutons;

  &:hover {
    @include boutons_hover;
  }

  &:focus-visible {
    @include boutons_hover;
    outline: 3px solid #000;
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
